import '../../styles/cv/cv_pdf_button.scss'

// Language
import { useLanguage } from '../../context/language_context'

function CvPdfButton() {

    const { language } = useLanguage()

    return (
        <a
            className="cv_pdf_button"
            href="/cv/cv_maurine_duet.pdf"
            target="_blank"
            rel="noreferrer"
        >
            {language === 'fr'
                ? 'Voir CV format PDF (FR & ENG)'
                : 'View resume as PDF (FR & ENG)'}
        </a>
    )
}

export default CvPdfButton